import { useState } from "react";
import { Language, dictionary } from "../../../utils/dictionary";
import { MetaLoginResult, useMetaSDK } from "../../../hooks/useMetaSDK";
import {
  ChannelIntegrationWizard,
  instagramChannelConfig,
} from "../ChannelWizard";

interface ModalInstagramIntegrationProps {
  setModalOpen: (open: boolean) => void;
  handleOAuthComplete: (data: MetaLoginResult) => void;
  loading: boolean;
  language: Language;
}

const ModalInstagramIntegration = ({
  setModalOpen,
  handleOAuthComplete,
  loading,
  language,
}: ModalInstagramIntegrationProps) => {
  const { sdkReady, launchInstagramLogin } = useMetaSDK();
  const [sdkLoading, setSdkLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleConnect = async () => {
    setError(null);
    setSdkLoading(true);
    try {
      const result = await launchInstagramLogin();
      handleOAuthComplete(result);
    } catch (err: unknown) {
      console.error("Instagram login failed:", err);
      setError(
        err instanceof Error
          ? err.message
          : dictionary["integration-error"]?.[language] || "Error connecting Instagram"
      );
    } finally {
      setSdkLoading(false);
    }
  };

  return (
    <ChannelIntegrationWizard
      config={instagramChannelConfig}
      language={language}
      loading={loading || sdkLoading}
      sdkReady={sdkReady}
      error={error}
      onClose={() => setModalOpen(false)}
      onConnect={handleConnect}
    />
  );
};

export default ModalInstagramIntegration;
